import { Box, Text, useClassNames } from '@factorialco/deprecated-design-system'
import { Moment } from 'moment'

import * as stylesRefs from 'modules/project_management/components/Schedule/Body/ScheduleItem/index.vanilla.css'

import { RowType, ScheduleRecordValuesType } from '../types'
import SubRow from './SubRow'

interface IRowProps {
  days: Moment[]
  dataRow: RowType
  openSidepanel: (data?: ScheduleRecordValuesType | null) => void
}

const Row = ({ days, dataRow, openSidepanel }: IRowProps) => {
  const cx = useClassNames(stylesRefs)

  return (
    <Box className={cx('scheduleItemRow')}>
      <Box
        className={cx('scheduleItemFirstColumn')}
        paddingLeft="s48"
        paddingTop="s8"
        paddingRight="s8"
      >
        <Text.Normal size="100" weight="medium" color="grey1000" ellipsis>
          {dataRow.firstColumn.title}
        </Text.Normal>
        <Text.Normal size="100" weight="normal" color="grey1000" ellipsis>
          {dataRow.firstColumn.subtitle}
        </Text.Normal>
      </Box>
      <Box flexDirection="column">
        {Object.keys(dataRow.records).map((key) => (
          <SubRow
            key={key}
            days={days}
            records={dataRow.records[key]}
            openSidepanel={openSidepanel}
          />
        ))}
      </Box>
    </Box>
  )
}

export default Row
